import { mockCompanyPosts } from "../seed/posts";
import * as _ from 'lodash';

export default class PostService {

    constructor() {}

    getPosts() {
        return _.shuffle(mockCompanyPosts);
    }
}